var map = {
	"./MobileLayout": [
		"916c",
		"chunk-6a1d0266"
	],
	"./MobileLayout.vue": [
		"916c",
		"chunk-6a1d0266"
	],
	"./PCLayout": [
		"0cc5",
		"chunk-566cd4ab"
	],
	"./PCLayout.vue": [
		"0cc5",
		"chunk-566cd4ab"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "9c46";
module.exports = webpackAsyncContext;